import { faBan, faX } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useRef, useState } from 'react'
import { thousandSeparator } from '../../utils/helpers'
import { Tooltip } from 'react-tooltip'

const AgentDetailsModal = (props) => {
    const textRef = useRef(null);
    const [copy, setCopy] = useState(false)

    const handleCopy = () => {
        const textToCopy = textRef.current.innerText;
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                setCopy(true)
                setTimeout(() => {
                    setCopy(false)
                }, 1500)
            })
            .catch((error) => {
            console.error('Error copying text:', error);
            });
    }

    return (
        <Transition appear show={ props.openModal } as={ Fragment }>
            <Dialog as="div" className="relative z-30" onClose={ () => props.setOpenModal(false) }>
                <Transition.Child
                    as={ Fragment }
                    enter="ease-out duration-150"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={ Fragment }
                            enter="ease-out duration-150"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-150"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className={ 'rounded-[10px] shadow-lg p-4 max-w-[100vw] w-96 relative ' + (props.agent?.status !== 'Active' ? 'bg-gradient-to-t from-white via-red-50 to-red-50 bg-opacity-90' : 'bg-white') }>
                                <div className='absolute top-0 right-0 p-2'>
                                    <button className='flex h-4 w-4 items-center justify-center' onClick={ () => props.setOpenModal(false) }>
                                        <FontAwesomeIcon icon={ faX } className='h-3 w-3' />
                                    </button>
                                </div>

                                {
                                    props.agent &&
                                    <div className='flex flex-col items-center justify-center'>
                                        <div className='rounded-full flex items-center justify-center w-28 h-28 shadow-sm cursor-pointer hover:scale-105 transition duration-150 ease-in-out hover:shadow overflow-hidden'>
                                            <img
                                                src={ props.agent.image ?? "https://iprofstore.blob.core.windows.net/general/agentDefault.png" }
                                                className="object-cover w-full h-full"
                                                alt={ props.agent?.name }
                                            />
                                        </div>

                                        <div className='mt-2'>
                                            {
                                                props.agent?.status !== 'Active' &&
                                                <div className='flex w-full justify-center items-center text-center mb-2 text-danger'>
                                                    <FontAwesomeIcon icon={ faBan } className='h-3.5 w-3.5' />
                                                    <span className='text-[10px] ml-1'>Suspended</span>
                                                </div>
                                            }

                                            <p className='font-semibold text-gray-one leading-[1.15]'>{ props.agent?.name }</p>
                                        </div>

                                        <div className='mt-4 flex items-center justify-between w-full'>
                                            <p className="text-xs text-gray-two leading-none">Direct Upline</p>
                                            <button onClick={ handleCopy } className='group relative'>
                                                <p ref={ textRef } className='font-semibold text-sm transition group-hover:text-primary text-gray-one leading-[1.15] anchor-element'>{ props.agent?.superior?.UserName.toUpperCase() ?? 'NO DIRECT UPLINE' }</p>
                                                <Tooltip anchorSelect='.anchor-element' content={ copy ? 'Name copied!' : 'Copy Name' } place='bottom' className='absolute whitespace-nowrap !left-full -translate-y-2 md:-translate-x-1/2 -translate-x-full text-[10px] bg-slate-400/[85%] text-white px-3 py-1 rounded-lg' />
                                            </button>
                                        </div>

                                        <div className='mt-3 flex items-center justify-between w-full'>
                                            <p className="text-xs text-gray-two leading-none">Group</p>
                                            <p className='font-semibold text-xs text-gray-one leading-[1.15]'>{ props.agent?.group }</p>
                                        </div>

                                        <div className='mt-3 flex items-center justify-between w-full'>
                                            <p className="text-xs text-gray-two leading-none">Subsale</p>
                                            <p className='font-semibold text-xs text-gray-one leading-[1.15]'>RM { props.agent.subsale ? thousandSeparator(props.agent?.subsale) : '0.00' }</p>
                                        </div>

                                        <div className='mt-3 flex items-center justify-between w-full'>
                                            <p className="text-xs text-gray-two leading-none">Project</p>
                                            <p className='font-semibold text-xs text-gray-one leading-[1.15]'>RM { props.agent.project ? thousandSeparator(props.agent?.project) : '0.00' }</p>
                                        </div>

                                        <div className='mt-3 flex items-center justify-between w-full'>
                                            <p className="text-xs text-gray-two leading-none">Total Commission</p>
                                            <p className='font-semibold text-xs text-gray-one leading-[1.15]'>RM { props.agent.totalCommission ? thousandSeparator(props.agent?.totalCommission) : '0.00' }</p>
                                        </div>
                                    </div>
                                }
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default AgentDetailsModal